export default __webpack_public_path__ + "static/media/LeekHotPot_04.5b704e6d.png";